import FooterLinks from '../../../ConfigAssistant/ConfigAssistantSteps/FooterLinks/FooterLinks';
import './FooterlinksSettings.css';
import React from 'react';

export default function FooterlinksSettings() {
  return (
    <div style={{ width: '50rem' }}>
      <FooterLinks isSettings={true} />
    </div>
  );
}
